// extracted by mini-css-extract-plugin
export default {"panContainer":"PanControls_panContainer__dLTrD","middleRow":"PanControls_middleRow__KPhlH","dark":"PanControls_dark__YPx-d"};